import type { CommaDelimitedLocationType, Provider } from '../types';
import { useLocationControl } from './use_location_control';
import { useCallback } from 'react';

export const useResultSelected = (
  locationType: CommaDelimitedLocationType,
  provider?: Provider
) => {
  const locationControl = useLocationControl(locationType, provider);

  return useCallback(
    (result) => {
      return locationControl.resultSelected(result);
    },
    [locationControl]
  );
};
